export default function ({ query }) {
  const utmCodes = {
    campaign: query?.utm_campaign,
    medium: query?.utm_medium,
    source: query?.utm_source,
    content: query?.utm_content
  };

  for (const key in utmCodes) {
    if (Object.prototype.hasOwnProperty.call(utmCodes, key)) {
      const element = utmCodes[key];
      if (element) {
        return utmCodes;
      }
    }
  }
  return undefined;
}
